import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../spinner'
import { ButtonContained, ButtonOutlined } from '../app-button/button'
import { required, url } from './validation/validation'
import InputOutlined from './field/inputOutlined'

const styles = theme => ({
  form: {
    width: '100%',
    marginTop: 16,
  },
  novalidate: {},

  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
  promoBtn: {
    width: 135,
    height: 48,
    marginBottom: 8,
    padding: 0,
    fontSize: 16,
    color: '#000000',
    border: 'solid 1px #bbbbbb',
    backgroundColor: '#fff',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#fff',
    },
  },
  btnRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

class PromocodeForm extends Component {
  state = {}

  resetValueField = name => {
    this.props.change(this.props.form, name, '')
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      isFetching,
      submitFailed,
      invalid,
      closePromo,
    } = this.props

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <Field
          name="promoCode"
          label="Введите код"
          component={InputOutlined}
          type="text"
          validate={[required]}
        />

        <div className={classes.btnRow}>
          <ButtonContained
            style={{
              height: 48,
              fontSize: 16,
              width: '55%',
              padding: 0,
              boxShadow: 'none',
            }}
            type="submit"
            color="primary"
            onClick={() => this.handleClick(classes, submitFailed)}
            text={isFetching ? <Spinner stroke={'#000'} /> : 'Применить'}
          />

          <ButtonOutlined
            handleClick={() => closePromo()}
            className={classes.promoBtn}
            color="secondary"
            text="Отказаться"
          />
        </div>
      </form>
    )
  }
}

const mapDispatchToProps = {
  change,
}

PromocodeForm = reduxForm({
  form: 'promocode',
})(
  connect(
    null,
    mapDispatchToProps
  )(PromocodeForm)
)

export default withStyles(styles)(PromocodeForm)
